import axios from 'axios';

//const API_URL = "http://localhost:4000"; 
const API_URL = "https://quintuusapi.pablogonzalez.ar"; 
//const API_URL = "https://quintuus.com/api/v1"; 

export const useApiAuth = () => {
  
  const login = (usuario, password) => {
    return axios.post(`${API_URL}/Account/Login`, {usuario, password});
  }

  const reloadToken = (token) => {
    return axios.post(`${API_URL}/Account/ReLogin`, {}, {headers : {Token : "Bearer " + token}});
  }

  const validateToken = (data) => {
    console.log(data)

    return axios.post(`${API_URL}/account/validateToken`, data);
  }

  return {login, reloadToken, validateToken};

}

const ApiBase = (controller, token) => {
  
  const index = () => {
    return axios.get(`${API_URL}/${controller}/list`, {headers : {Authorization : "Bearer " + token}});
  }
  
  const editForm = (id, ) => {
    return axios.get(`${API_URL}/${controller}/EditForm/${id}`, {headers : {Authorization : "Bearer " + token}});
  }
  
  const editItem = (id, data) => {
    return axios.put(`${API_URL}/${controller}/${id}`, data, {headers : {Authorization : "Bearer " + token}});
  }
  
  const addForm = () => {
    return axios.get(`${API_URL}/${controller}/CreateForm`, {headers : {Authorization : "Bearer " + token}});
  }
  
  const addItem = (data) => {
    return axios.post(`${API_URL}/${controller}`, data, {headers : {Authorization : "Bearer " + token}});
  }
  
  const removeItem = (id) => {
    return axios.delete(`${API_URL}/${controller}/${id}`, {headers : {Authorization : "Bearer " + token}});
  }
  
  return {index, editForm, editItem, addForm, addItem, removeItem};
}
export const useApiUsuarios = (getState) => ApiBase("usuarios", getState().auth.token);
export const useApiAvisos = (getState) => ApiBase("avisos", getState().auth.token);
export const useApiPublicaciones = (getState) => ApiBase("publicaciones", getState().auth.token);


